export default __webpack_public_path__ + "static/media/Vero.TOS.30bc1f90.docx";